import React from 'react';
import store from 'store';
import u from '../utilities/Utilities';
import AppLayout from '../components/AppLayout';
import {Databox,Segment,Step,LoadGraphic,UploadPhoto,Dropzone,SegmentComplete} from '../components/Common';
import {Date,Select,Box,Button,TextButton,Info} from '../components/Input';
import {Spreadsheet} from '../data/Mimetypes';
import {EstateUtilities} from './Estate';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import {Link} from 'react-router-dom';
import "../styles/dashboard.scss";
import PropTypes from 'prop-types';
import moment from 'moment';
import {PieChart} from './Reports';
import {Line, Bar} from 'react-chartjs-2';

export default class Dashboard extends React.Component{

    state={
        action:"No Permission",
        actionLabel:"",
        dormOptions:[],
        latestEvents:[],
        name:u.getFullName(),
        avatar:u.getUserAvatar(),
        quickSelected:"",
        quickActions:[],
        rfid:"",
        dimensions:{width:0,height:0},
    };

    componentDidMount=()=>{
        const dashboardPermissions = u.getPermissions("dashboard");
        let dashboardCount=0;
        for(var key in dashboardPermissions){
            if(dashboardPermissions[key]){
                dashboardCount++;
            }
        }
        this.setState({
            rfid:store.get("staffRFID"),
            quickActions:[
                {label:"Attendance",component:QuickAttendance,ref:"quickAttendance",image:"/images/dashboard/attendance.png",permission:(u.getPermissions("combined").attendance >= 1)},
                {label:"Meal Type",component:MealType,ref:"mealType",image:"/images/dashboard/food.png",permission:(u.getPermissions("combined").mealType >= 1)},
                {label:"Go To Room",component:GoToRoom,ref:"goToRoom",image:"/images/dashboard/go-to-room.png",permission:(u.getPermissions("estate").view >= 1)},
                {label:"Dashboards",component:CustomDashboard,ref:"customDashboard",image:"/images/dashboard/custom-dashboard.png",permission:(dashboardCount>0)},
                {label:"Vitals",component:VitalsDashboard,ref:"vitalsDashboard",image:"/images/dashboard/vitals-dashboard.png",permission:(u.getPermissions("resident").view >= 1)},
                {label:"Dorm QRCode",component:PrintDorm,ref:"printDorm",image:"/images/dashboard/print-dorm.png",permission:(u.getPermissions("resident").view >= 1)},
                {label:"Profile Pic",component:ProfilePic,ref:"profilePic",image:"/images/dashboard/upload-avatar.png",permission:true,onComplete:this.onNewProfile},
                {label:"Logout",ref:"logout",image:"/images/dashboard/logout.png",permission:true},
            ]
        });

        const action = store.get("dashboard-action");
        const actionLabel = store.get("dashboard-action-label");
        store.remove("dashboard-action");
        store.remove("dashboard-action-label");
        this.setState({action:action,actionLabel:actionLabel});
        this.getDormOptions();
        this.getLatestEvents();
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(callback)=>{
                let dormWithEmpty = callback.slice(0);
                dormWithEmpty.unshift({value:"-1",label:"Select a dormitory"});
                this.setState({dormOptions:callback});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getLatestEvents=()=>{
        u.post({
            url:"/api/get-dashboard-history",
            data:{},
            success:(callback)=>{
                this.setState({latestEvents:callback});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onQuickAction=(e)=>{
        const index = parseInt(e.currentTarget.id);
        const target=this.state.quickActions[index];

        if(target.ref=="logout"){
            u.logout();
            return 0;
        }

        if(target.ref=="myEvents"){
            store.set("history-list","@staff("+u.getFullName()+")");
            window.open("/history-list","_blank");
            return 0;
        }

        if(target.ref == this.state.quickSelected){
            this.setState({quickSelected:"none"});
        }
        else{
            this.setState({quickSelected:target.ref});
        }
    }

    onCancelQuickAction=()=>{
        this.setState({quickSelected:""});
    }

    onNewProfile=(link)=>{
        store.set("avatarLink",link);
        this.setState({avatar:link,quickSelected:"none"});
    }

    render=()=>{
        const { width, height } = this.state.dimensions;

        return (
            <AppLayout settings={{title:"Dashboard",permission:"none",url:"/dashboard"}}>

                {
                    (this.state.action == "No Permission")
                        ?
                        <div style={{textAlign:"center"}} className="text-negative">No permission to access {this.state.actionLabel}. Please request for the permission from your system administrator</div>
                        :
                        ""
                }

                <Databox active={true} align="center" margin={"30px auto"}>
                    <img src={u.getAvatarLink(this.state.avatar)} style={{width:"100px",maxWidth:"50%",margin:"auto",borderRadius:"50%"}}/>

                    <h2 className="theme-emphasis">Welcome Back, {this.state.name}</h2>

                    <div className="dashboard-qr">
                        <Measure bounds onResize={contentRect => {this.setState({ dimensions: contentRect.bounds })}}>
                            {
                                ({measureRef})=>
                                    (
                                        <div ref={measureRef} className="dashboard-qr-image">
                                            <QRCode value={this.state.rfid}
                                                    level="H"
                                                    fgColor="#000"
                                                    size={width}
                                                    imageSettings={{
                                                        src:"/images/app/app-logo-small.png",
                                                        width:30,
                                                        height:30,
                                                        excavate:true,
                                                    }}
                                                    />
                                        </div>
                                    )
                            }
                        </Measure>
                    </div>

                    <div className="pending-tasks">
                        <h3>My Latest Events</h3>
                        <div style={{width:"750px",maxWidth:"95%",margin:"auto",border:"1px solid #f4f4f4",borderRadius:"5px"}}>
                        {
                            (this.state.latestEvents.length > 0)
                                ?
                                <div>
                                    <div style={{maxHeight:"200px",overflow:"auto"}}>
                                    {
                                        this.state.latestEvents.map(
                                            (item,index)=>{
                                                const isToday = (moment().diff(item.dateTime,"days") == 0);
                                                return (
                                                    <div key={index} className="pending-task-item">
                                                        <div className="pending-task-event">
                                                            <span>{u.capitalize(item.action,true)} </span>
                                                            <span>{(item.targetLink==null) ? item.targetName : <Link to={item.targetLink} id={item.targetLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.targetName}</Link>}</span>
                                                            <span>{(item.targetField==null) ? "" : " (" + item.targetField + ")"}</span>
                                                            <span>{(item.from == null) ? "" : ((item.fromLink == null) ? " from "+item.from : <span> from <Link to={item.fromLink} id={item.fromLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.from}</Link></span>)}</span>
                                                            <span>{(item.to == null) ? "" : ((item.toLink == null) ? " to "+item.to : <span> to <Link to={item.toLink} id={item.toLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.to}</Link></span>)}</span>
                                                        </div>
                                                        <div className="pending-task-date">
                                                            {moment(item.dateTime).format((isToday) ? "h:mma" : "DD MMM YY")}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                                :
                                <div className="pending-task-empty">No events performed</div>
                        }
                        </div>
                    </div>

                    <div className="quick-actions">
                        <h3>Quick Actions</h3>
                        <div>
                            {
                                this.state.quickActions.map(
                                    (item,index)=>{
                                        if(!item.permission){
                                            return null;
                                        }
                                        return (
                                            <div className="quick-action-item" key={index} id={index+""} onClick={this.onQuickAction}>
                                                <img src={item.image}/>
                                                <div>{item.label}</div>
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>

                        <div style={{width:"1280px",maxWidth:"98%",margin:"auto"}}>
                            <div className="quick-action-content">
                                {
                                    this.state.quickActions.map(
                                        (item,index)=>{
                                          if(typeof item.component == "undefined"){
                                              return (<div key={index}/>)
                                          }
                                          return React.createElement(
                                              item.component,
                                              {
                                                  key:index,
                                                  active:(this.state.quickSelected == item.ref),
                                                  onCancel:this.onCancelQuickAction,
                                                  onComplete:item.onComplete,
                                                  dormOptions:this.state.dormOptions,
                                                  ref:item.ref,
                                              }
                                        );
                                        }
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </Databox>
            </AppLayout>
        )
    }
}

class GoToRoom extends React.Component{

    state={
        error:"",
        options:{
            clusterOptions:[],
            buildingOptions:[],
            levelOptions:[],
            roomOptions:[],
        },
        config:{},
    };

    componentDidMount=()=>{
        this.setState({
            config:EstateUtilities.getDormConfig()
        });
    }

    getEstateOptions=(type,id)=>{
        const nextType = EstateUtilities.getNextType(type);
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:nextType,
                id:id
            },
            success:(callback)=>{
                const config = this.state.config;
                let options = this.state.options;
                callback.unshift({value:"none",label:"Select " + config[nextType+"Single"]});
                options[nextType+"Options"] = callback;

                if(nextType == "cluster"){
                    options.buildingOptions = [{value:"none",label:"Select " + config.buildingSingle}];
                    options.levelOptions = [{value:"none",label:"Select " + config.levelSingle}];
                    options.roomOptions = [{value:"none",label:"Select " + config.roomSingle}];
                }
                else if(nextType == "building"){
                    options.levelOptions = [{value:"none",label:"Select " + config.levelSingle}];
                    options.roomOptions = [{value:"none",label:"Select " + config.roomSingle}];
                }
                else if(nextType == "level"){
                    options.roomOptions = [{value:"none",label:"Select " + config.roomSingle}];
                }

                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onChange=(value,label,index,option)=>{
        if(value != "none" && value != "all"){
            this.getEstateOptions(label,value);
        }
    }

    onSubmit=()=>{
        this.setState({error:""});
        const refs=["dorm","cluster","building","level","room"];
        let location = {};

        for(var i=0; i<refs.length; i++){
            const item = (this.refs[refs[i]]) ? this.refs[refs[i]].validate() : {valid:true};
            if(!item.valid){
                this.setState({error:item.value});
                return 0;
            }
            location[refs[i]]=item.value;
        }

        window.open("/estate-list/room/"+location.room,"_blank");
    }

    render=()=>{
        const config = this.state.config;
        const options = this.state.options;

        return(
            <Segment active={this.props.active} align="center">
                <div className="dashboard-segment">
                    <h3>Select a Room</h3>
                    <div className="segment-full-item">
                        <div className="segment-item-label">Dormitory</div>
                        <div className="segment-item-input"><Select ref="dorm" label="Dormitory" field="dorm" rules={{required:true}} values={{options:this.props.dormOptions}} onChange={this.onChange}/></div>
                    </div>

                    {
                      (config.cluster)
                        ?
                        <div className="segment-full-item">
                            <div className="segment-item-label">{config.clusterSingle}:</div>
                            <div className="segment-item-input"><Select ref="cluster" label={config.clusterSingle} field="cluster" rules={{required:true}} values={{options:options.clusterOptions}} onChange={this.onChange}/></div>
                        </div>
                        :
                        null
                    }

                    {
                      (config.building)
                        ?
                        <div className="segment-full-item">
                            <div className="segment-item-label">{config.buildingSingle} :</div>
                            <div className="segment-item-input"><Select ref="building" label={config.buildingSingle}  field="building" rules={{required:true}} values={{options:options.buildingOptions}} onChange={this.onChange}/></div>
                        </div>
                        :
                        null
                    }

                    <div className="segment-full-item">
                        <div className="segment-item-label">{config.levelSingle} :</div>
                        <div className="segment-item-input"><Select ref="level" label={config.levelSingle}  field="level" rules={{required:true}} values={{options:options.levelOptions}} onChange={this.onChange}/></div>
                    </div>

                    <div className="segment-full-item">
                        <div className="segment-item-label">{config.roomSingle} :</div>
                        <div className="segment-item-input"><Select ref="room" label={config.roomSingle}  field="room" rules={{required:true}} values={{options:options.roomOptions}} onChange={this.onChange}/></div>
                    </div>

                    <div className="segment-error">{this.state.error}</div>

                    <div className="segment-buttons">
                        <Button type="medium" onClick={this.props.onCancel}>Cancel</Button>
                        <Button type="medium" onClick={this.onSubmit}>Go</Button>
                    </div>
                </div>
            </Segment>
        )
    }
}

class ProfilePic extends React.Component{

    id=u.getUserID();

    state={
        active:false
    };

    static getDerivedStateFromProps(props,state){
        if(props.active != state.active){
            state.active=props.active;
            state.update=true;
        }
        return state;
    }

    componentDidUpdate=()=>{
        if(this.state.update){
            this.refs["photo"].show(this.props.active);
            this.setState({update:false});
        }
    }

    onToggleForm=()=>{
        this.props.onCancel();
    }

    onComplete=(link)=>{
        //Commit to store, refresh page image
        this.props.onComplete(link);
    }

    render=()=>{
        return(
            <div className="dashboard-segment">
                <UploadPhoto ref="photo" reference="photo" id={this.id}
                             url={"/api/commit-staff-avatar"} fieldname="avatarLink" onUpload={this.onComplete}
                             onToggleForm={this.onToggleForm} noTitle={true}/>
            </div>
        )
    }
}

class PrintDorm extends React.Component{

    state={
        error:"",
    };

    onSubmit=()=>{
        const dormID = this.refs['dorm'].validate();
        if(!dormID.valid){
            this.setState({error:dormID.value});
            return 0;
        }
        store.set("print-dorm",{dormID:dormID.value,dormName:dormID.option.label});
        window.open("/print-dorm","_blank","width=800,height=800,left=200,top=100");
    }

    render=()=>{
        return(
            <Segment active={this.props.active} align="center">
                <div className="dashboard-segment" style={{padding:"30px 0"}}>
                    <h3>Select the dormitory to print</h3>
                    <div className="dashboard-segment-text">Print respectives dormitory's QRCode used for Resident's to Login to Smartdorm Mobile App</div>
                    <div className="page-error">{this.state.error}</div>
                    <div className="segment-full-item" style={{padding:"20px 0"}}>
                        <div className="segment-item-label">Dormitory</div>
                        <div className="segment-item-input"><Select ref="dorm" label="Dormitory" field="dorm" rules={{required:true}} values={{options:this.props.dormOptions}}/></div>
                    </div>
                    <div className="segment-buttons">
                        <Button type="medium" onClick={this.props.onCancel}>Cancel</Button>
                        <Button type="medium" onClick={this.onSubmit}>Go</Button>
                    </div>
                </div>
            </Segment>
        )
    }
}

class VitalsDashboard extends React.Component{

    state={
        error:"",
    };

    onSubmit=()=>{
        const dormID = this.refs['dorm'].validate();
        if(!dormID.valid){
            this.setState({error:dormID.value});
            return 0;
        }
        window.open("/vitals-dashboard/"+dormID.value,"_blank");
    }

    render=()=>{
        return(
            <Segment active={this.props.active} align="center">
                <div className="dashboard-segment" style={{padding:"30px 0"}}>
                    <h3>Select the dormitory to monitor</h3>
                    <div className="dashboard-segment-text">View real time information about critical patients and compliance on vital submissions</div>
                    <div className="page-error">{this.state.error}</div>
                    <div className="segment-full-item" style={{padding:"20px 0"}}>
                        <div className="segment-item-label">Dormitory</div>
                        <div className="segment-item-input"><Select ref="dorm" label="Dormitory" field="dorm" rules={{required:true}} values={{options:this.props.dormOptions}}/></div>
                    </div>
                    <div className="segment-buttons">
                        <Button type="medium" onClick={this.props.onCancel}>Cancel</Button>
                        <Button type="medium" onClick={this.onSubmit}>Go</Button>
                    </div>
                </div>
            </Segment>
        )
    }
}

class MealType extends React.Component{

    state={
        step:"view",
        loading:false,
        loadText:"",
    };

    onDownload=()=>{
        this.setState({loading:true,loadText:"Preparing..."});
        const dormID = this.refs['dormID'].validate();
        if(!dormID.valid){
            this.setState({error:dormID.value});
            return 0;
        }
        u.post({
            url:"/api/download-meal-type-template",
            data:{
                dormID:dormID.value,
            },
            success:({filename,filestamp})=>{
                this.filename=filename;
                this.filestamp=filestamp;
                this.download(this.filename,this.filestamp);
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    download=(filename,filestamp)=>{
        this.setState({loading:true,loadText:"Downloading..."});
        u.download(filename,filestamp,
          ()=>{
            this.setState({loading:false,step:"download",error:""});
        },(error)=>{
            this.setState({loading:false,error:error});
        });
    }

    onUploaded=(url)=>{
        this.setState({loadText:"Processing..."});
        u.post({
            url:"/api/upload-meal-type-template",
            data:{
                userFilename:this.filename,
                filename:url
            },
            success:()=>{
                this.setState({step:"upload",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    onCancel=()=>{
        this.setState({step:"view",error:""});
        this.props.onCancel();
    }

    render=()=>{
        return(
            <Segment active={this.props.active}>
                <div className="dashboard-segment" style={{position:"relative",textAlign:"center"}}>
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                    <Step active={this.state.step == "view"}>
                        <h3>Meal Types</h3>

                        <div className="dashboard-segment-text">
                            Upon download, all active residents<Info style={{width:"13px",height:"13px",verticalAlign:"top"}} title="<b>Active Resident</b><br/>Any resident who is not in the checked-out state is considered to be active"/> in the selected dormitory will be generated into the spreadsheet along with
                            any relevant data that has been uploaded previously. If the resident is checked-out, his entry will not be included in the spreadsheet
                        </div>
                        <div style={{margin:"30px auto"}}>
                              <div className="segment-full-item">
                                  <div className="segment-item-label">Dormitory:</div>
                                  <div className="segment-item-input">
                                      <Select ref="dormID" label="Dormitory" values={{options:this.props.dormOptions}} rules={{required:true}}/>
                                  </div>
                              </div>
                        </div>

                        <div>
                            <Dropzone label="meal-type"
                                      accessibleForPreview={false}
                                      onAdded={(userfilename)=>{this.setState({loading:true,loadText:"Uploading..."}); this.userfilename=userfilename;}}
                                      onUploaded={this.onUploaded}
                                      onError={(error)=>{this.setState({loading:false,error:error})}}
                                      onProgress={(progress)=>{this.setState({loadText:"Uploading..." + progress + "%"})}}
                                      filetypes={Spreadsheet}
                                      buttonOnly={true}>
                                      Upload Spreadsheet
                           </Dropzone>

                           <div className="dashboard-segment-text-small">Note: Upon upload, existing data will be overwritten hence this step cannot be undone</div>
                        </div>

                        <div className="segment-buttons">
                            <div className="segment-error">{this.state.error}</div>
                            <Button onClick={this.props.onCancel}>Cancel</Button>
                            <Button onClick={this.onDownload}>Download</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step == "download"}>
                        <div className="segment-content" style={{padding:"30px 0 10px 0"}}>
                            <h3>Download Has Started</h3>
                            <div className="segment-note"><i>Note: If your download does not automatically start, please click <span className="segment-link" onClick={
                              ()=>{
                                this.download(this.filename,this.filestamp);
                              }}>here</span></i></div>
                            <div className="segment-buttons">
                                <div className="segment-error">{this.state.error}</div>
                                <Button type="medium" onClick={this.onCancel}>Close</Button>
                            </div>
                        </div>
                    </Step>

                    <Step active={this.state.step=="upload"}>
                        <div style={{padding:"30px 0 10px 0"}}>
                            <SegmentComplete onComplete={this.onCancel}>File has been successfully uploaded</SegmentComplete>
                        </div>
                    </Step>
                </div>
            </Segment>
        )
    }
}

class CustomDashboard extends React.Component{

    state={
        error:"",
        dashboardOptions:[],
    };

    componentDidMount=()=>{
        u.post({
            url:"/api/get-custom-dashboards",
            data:{},
            success:(dashboardOptions)=>{
                this.setState({dashboardOptions:dashboardOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onSubmit=()=>{
        this.setState({error:""});
        const dormID = this.refs['dorm'].validate();
        if(!dormID.valid){
            this.setState({error:dormID.value});
            return 0;
        }
        const dashboard = this.refs['dashboard'].validate();
        if(!dashboard.valid){
            this.setState({error:dashboard.value});
            return 0;
        }

        if(dashboard.value == "indirect"){
            window.open(dashboard.option.indirect[dormID.value]+"/"+dormID.value,"_blank");
        }
        else{
            window.open(dashboard.value+"/"+dormID.value,"_blank");
        }
    }

    render=()=>{
        return(
            <Segment active={this.props.active} align="center">
                <div className="dashboard-segment" style={{padding:"30px 0"}}>
                    <h3>Select the dormitory and dashboard</h3>
                    <div className="dashboard-segment-text">Open real time dashboards to view an overview of the respective dormitory</div>
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-full-item" style={{padding:"20px 0 0 0"}}>
                        <div className="segment-item-label">Dormitory</div>
                        <div className="segment-item-input"><Select ref="dorm" label="Dormitory" field="dorm" rules={{required:true}} values={{options:this.props.dormOptions}}/></div>
                    </div>
                    <div className="segment-full-item">
                        <div className="segment-item-label">Dashboard</div>
                        <div className="segment-item-input"><Select ref="dashboard" label="Dashboard" field="dashboard" rules={{required:true}} values={{options:this.state.dashboardOptions}}/></div>
                    </div>
                    <div className="segment-buttons">
                        <Button type="medium" onClick={this.props.onCancel}>Cancel</Button>
                        <Button type="medium" onClick={this.onSubmit}>Go</Button>
                    </div>
                </div>
            </Segment>
        )
    }
}

class QuickAttendance extends React.Component{

    state={
        step:"view",
        entryData:{},
        eventList:[],
    }

    bgColors={
      "view":"#fff",
      "valid":"#95fcaf",//Success
      "not-valid":"#faf1af",//Warning
      "error":"#ffada6",//Error
    }

    componentDidMount=()=>{
        this.getEventList();
        document.addEventListener("keypress",this.onKeyPress);
    }

    componentWillUnmount=()=>{
        document.removeEventListener("keypress",this.onKeyPress);
    }

    onKeyPress=(event)=>{
        const keyName = event.key;
        console.log(keyName);
        if(this.state.step != "view"){
            if(keyName=="Enter" || keyName==" "){
                this.onBack();
            }
        }
    }

    getEventList=()=>{
        u.post({
            url:"/api/get-attendance-events",
            data:{},
            success:(eventList)=>{
                this.setState({eventList:eventList});
            },
            error:(error)=>{
                this.setState({error:error})
            }
        });
    }

    onChange=(value,field,index)=>{
        let entryData=this.state.entryData;
        entryData[field]=value;
        this.setState({entryData:entryData});
    }

    onSubmit=()=>{
        const keys=["event","tenantID"];
        let data={};
        for(var i=0; i<keys.length; i++){
            const current=this.refs[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }
        u.post({
            url:"/api/submit-attendance-entry",
            data:data,
            success:({valid,reason})=>{
                this.setState({step:((valid)?"valid":"not-valid"),reason:reason});
            },
            error:(error)=>{
                console.log(error);
                this.setState({step:"error",error:error.reason});
            }
        });
    }

    onBack=()=>{
        let entryData=this.state.entryData;
        entryData.tenantID="";
        this.setState({
            step:"view",
            entryData:entryData,
            error:""
        });
    }

    render=()=>{
        const {entryData}=this.state;
        return (
            <Segment active={this.props.active} align="center">
                <div className="dashboard-segment attendance-segment" style={{padding:"30px 0",backgroundColor:this.bgColors[this.state.step]}}>
                    <Step active={this.state.step == "view"}>
                        <h3>Select the event and scan resident barcode / app QR</h3>

                        <div className="dashboard-segment-text">Add attendance entry to the respective resident for the selected event</div>

                        <div className="segment-full-item" style={{padding:"20px 0 0 0"}}>
                            <div className="segment-item-label">Event:</div>
                            <div className="segment-item-input">
                                <Select ref="event"
                                        label="Event"
                                        field="event"
                                        rules={{required:true}}
                                        values={{
                                          value:entryData.event,
                                          options:this.state.eventList
                                        }}
                                        onChange={this.onChange}
                                        />
                            </div>
                        </div>

                        <div className="segment-full-item" style={{padding:"0"}}>
                            <div className="segment-item-label">Resident ID:</div>
                            <div className="segment-item-input">
                                <Box ref="tenantID"
                                     label="Resident ID"
                                     field="tenantID"
                                     rules={{required:true}}
                                     values={{value:entryData.tenantID}}
                                     onChange={this.onChange}
                                     autoFocus={true}
                                     onEnterKey={this.onSubmit}
                                     />
                            </div>
                        </div>


                        <div className="segment-buttons">
                            <div className="segment-error">{this.state.error}</div>
                            <Button type="medium" onClick={this.props.onCancel}>Cancel</Button>
                            <Button type="medium" onClick={this.onSubmit}>Go</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step=="valid"}>
                        <div className="attendance-acknowledgement">
                            <img src="/images/dashboard/attendance/valid.png"
                                 className="attendance-img"/>
                            <h2>Successfully Created Attendance Entry</h2>
                        </div>
                        <div>
                            <Button onClick={this.onBack}>Back</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step=="not-valid"}>
                        <div className="attendance-acknowledgement">
                            <img src="/images/dashboard/attendance/not-valid.png"
                                 className="attendance-img"
                                 />
                            <h2>{this.state.reason}</h2>
                        </div>
                        <div>
                            <Button onClick={this.onBack}>Back</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step=="error"}>
                        <div className="attendance-acknowledgement">
                            <img src="/images/dashboard/attendance/error.png"
                                 className="attendance-img"
                                 />
                            <h2>{this.state.error}</h2>
                        </div>
                        <div>
                            <Button onClick={this.onBack}>Back</Button>
                        </div>
                    </Step>
                </div>
            </Segment>
        )
    }
}

export class DashboardAnalytic extends React.Component{

    state={
        dashboards:[],
        showMenu:false,
    }

    componentDidMount=()=>{
        this.getDashboards();
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount=()=>{
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    getDashboards=async ()=>{
        try{
            const response=await u.postAsync({
                url:(this.props.getURL) ? this.props.getURL : "/api/get-available-dashboards"
            });
            this.setState({dashboards:this.sortDashboard(response.data)});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    sortDashboard=(dashboards,update)=>{
        dashboards = dashboards.sort((a,b)=>{
            if(a.selected == b.selected){
                return a.order-b.order;
            }
            return b.selected - a.selected ;
        });

        dashboards = dashboards.map((item,index)=>{
            item.order=index;
            item.sync=moment().format("DDHHmmssSSS");
            return item;
        });

        if(update){
            u.postAsync({
                url:"/api/update-user-dashboard",
                data:{
                    settings: dashboards.map((item)=>{
                        return {
                            key:item.value,
                            order:item.order,
                            selected:item.selected,
                            size:item.size
                        };
                    })
                }
            });
        }

        return dashboards;
    }

    onChangeSelect=(value,field,index)=>{
        let {dashboards}=this.state;
        dashboards[index][field]=value;
        u.postAsync({
            url:"/api/update-user-dashboard",
            data:{
                settings: dashboards.map((item)=>{
                    return {
                        key:item.value,
                        order:item.order,
                        selected:item.selected,
                    };
                })
            }
        });
        this.setState({dashboards:dashboards});
    }

    onDragStart=(e,index)=>{
        //e.preventDefault();
        this.drag={index:index}
        this.setState({dragging:true,dragOver:-1});
    }

    onDragEnd=(e)=>{
        this.setState({dragging:false,dragOver:-1});
    }

    onDragOver=(e,index,direction)=>{
        e.preventDefault();
        this.drop={
            index:index,
            direction:direction,
        };
        this.setState({dragOver:index,dragOverDir:direction});
    }

    onDragLeave=(e,index,direction)=>{
        if(this.drop.index == index && this.drop.direction == direction){
            //If left the module itself
            this.setState({dragOver:-1});
        }
    }

    onDrop=(e)=>{
        e.preventDefault();
        this.setState({dragOver:-1,dragging:false});
        let dashboards = JSON.parse(JSON.stringify(this.state.dashboards));
        let drag=this.drag.index;
        let drop=this.drop.index;
        const direction = this.drop.direction;

        if(drag==drop){
            return 0;
        }

        if(direction == "right"){
            drop++;
        }
        if(drop == "end"){
            dashboards[drag].order=dashboards.length;
        }
        else{
            dashboards[drag].order=drop;
            for(var i=drop; i<dashboards.length; i++){
                if(i!=drag){
                    dashboards[i].order++;
                }
            }
        }
        this.setState({dashboards:this.sortDashboard(dashboards,true)});
    }

    onToggleMenu=()=>{
        this.setState({showMenu:!this.state.showMenu});
    }

    onSetData=(data,index)=>{
        let {dashboards}=this.state;
        dashboards[index].data=data;
        this.setState({dashboards:dashboards});
    }

    handleClickOutside=(event)=>{
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({showMenu:false});
        }
    }

    onClickScale=(index)=>{
        let {dashboards}=this.state;
        dashboards[index].size = (dashboards[index].size == 3) ? 1 : dashboards[index].size+1;
        this.setState({dashboards:dashboards});

        u.postAsync({
            url:"/api/update-user-dashboard",
            data:{
                settings: dashboards.map((item)=>{
                    return {
                        key:item.value,
                        order:item.order,
                        selected:item.selected,
                        size:item.size
                    };
                })
            }
        });
    }

    render=()=>{
        const {dashboards,dragOver,dragOverDir,dragging,showMenu}=this.state;
        const animate = !dragging && !showMenu;

        return (
            <div className="personalize-dashboard-container">
                {
                    (this.props.noMenu)
                        ?
                        null
                        :
                        <div className='pdc-menu' ref={(ref)=>{this.wrapperRef=ref}}>
                            <div className='pdc-menu-toggle' onClick={this.onToggleMenu}>
                                <img src="images/input/gear.png"/>
                            </div>
                            {
                                (showMenu)
                                    ?
                                    <div className='pdc-menu-options'>
                                        <span className='pdc-menu-title'><b>Custom Dashboard Reports</b></span>
                                        <div className='pdc-menu-scroll'>
                                            {
                                                dashboards.map((item,index)=>{
                                                    return (
                                                        <div key={item.order+"-"+item.sync} className='pdc-option'>
                                                            <Checkbox values={{value:item.selected}}
                                                                    field="selected"
                                                                    index={index}
                                                                    onChange={this.onChangeSelect}
                                                                    />
                                                            <span>{item.label}</span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                }
                

                <div className='pdc-gallery'>
                {
                    dashboards.map(
                        (item,index)=>{
                            if(!item.selected){
                                return null;
                            }
                            return(
                                <div className={'pdc-graph' +
                                                ((dragOver == index && dragOverDir=="left") ? " drag-left" : "") +
                                                ((dragOver == index && dragOverDir=="right") ? " drag-right" : "")
                                                + " size-" + item.size
                                                }
                                     key={item.order + "-" + item.sync}>

                                    <div className='drop-left' style={{zIndex:(dragging) ? 100 : 0}}
                                         onDragOver={(e)=>{this.onDragOver(e,index,"left")}}
                                         onDragLeave={(e)=>{this.onDragLeave(e,index,"left")}}
                                         onDrop={(e)=>{this.onDrop(e,index,"left")}}
                                         />
                                    <div className='drop-right' style={{zIndex:(dragging) ? 100 : 0}}
                                         onDragOver={(e)=>{this.onDragOver(e,index,"right")}}
                                         onDragLeave={(e)=>{this.onDragLeave(e,index,"right")}}
                                         onDrop={(e)=>{this.onDrop(e,index,"right")}}
                                         />
                                    {
                                        (this.props.noDrag)
                                            ?
                                            null
                                            :
                                            <div draggable={true}
                                                    onDragStart={(e)=>{this.onDragStart(e,index)}}
                                                    onDragEnd={this.onDragEnd}
                                                    onDragOver={(e)=>{e.preventDefault()}}
                                                    className='pdc-drag'
                                                    >
                                                <img src="images/input/drag.png"/>
                                            </div>
                                    }
                                    

                                    {
                                        (item.dataType == "pie" || this.props.noSize)
                                            ?
                                            null
                                            :
                                            <div className='pdc-drag right' onClick={()=>{this.onClickScale(index)}}>
                                                <div className='pdc-size'>{item.size}</div>
                                                <img src="images/input/double-arrow.png"/>
                                            </div>
                                    }


                                    {
                                        (item.dataType == "line")
                                            ?
                                            <DashboardLineChart key={index}
                                                                index={index}
                                                                onSetData={this.onSetData}
                                                                type={item.value}
                                                                data={item.data}
                                                                animate={animate}
                                                                overrideURL={this.props.overrideURL}
                                                                />
                                            :
                                            null
                                    }
                                    {
                                        (item.dataType == "bar")
                                            ?
                                            <DashboardBarChart key={index}
                                                               index={index}
                                                               onSetData={this.onSetData}
                                                               type={item.value}
                                                               data={item.data}
                                                               animate={animate}
                                                               overrideURL={this.props.overrideURL}
                                                               />
                                            :
                                            null
                                    }
                                    {
                                        (item.dataType == "pie")
                                            ?
                                            <DashboardPieChart key={index}
                                                               index={index}
                                                               onSetData={this.onSetData}
                                                               type={item.value}
                                                               data={item.data}
                                                               animate={animate}
                                                               overrideURL={this.props.overrideURL}
                                                               />
                                            :
                                            null
                                    }
                                    {
                                        (item.dataType == "list")
                                            ?
                                            <DashboardListChart key={index}
                                                                index={index}
                                                                onSetData={this.onSetData}
                                                                type={item.value}
                                                                data={item.data}
                                                                animate={animate}
                                                                overrideURL={this.props.overrideURL}
                                                                />
                                            :
                                            null
                                    }
                                </div>
                            )
                        }
                    )
                }
                </div>
            </div>
        )
    }
}

class DashboardPieChart extends React.Component{
    state={
        loading:true,
        loadText:"Preparing...",
        content:{},
        isEmpty:true,
    };

    componentDidMount=()=>{
        if(this.props.data){
            this.setState({content:this.props.data,loading:false});
            this.drawOnce();
        }
        else{
            this.getChartData();
        }
    }

    getChartData=async ()=>{
        try{
            const response = await u.postAsync({
                url:(this.props.overrideURL) ? this.props.overrideURL : "/api/get-dashboard-content",
                data:{
                    type:this.props.type,
                    testDelay:500,
                }
            });
            this.props.onSetData(response.data,this.props.index);
            this.setState({
                content:response.data,
                isEmpty:(response.data.data.reduce((a,b)=>a+b,0) == 0),
                loading:false,
            });
            this.drawOnce();
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    drawOnce=()=>{
        this.setState({drawOnce:true});
        setTimeout(()=>{
            this.setState({drawOnce:false})
        },50);
    }
    /*
    content: PropTypes.shape({
        showLegend: PropTypes.bool,
        backgroundColor: PropTypes.array,
        data: PropTypes.array,
        labels: PropTypes.array,
        tooltips: PropTypes.bool,
    }).isRequired,
    isEmpty:PropTypes.bool,
    */
    render=()=>{
        const {content,isEmpty,drawOnce,loading}=this.state;
        return(
            <div className='dashboard-chart-container'>
                <div className='dpc-title'><b>{content.title}</b></div>
                <div className='dashboard-chart-content pie'>
                {
                        (loading)
                            ?
                            <div className='dpc-placeholder'>
                                <LoadGraphic active={true} text="Preparing..." grey={true}/>
                            </div>
                            :
                            <PieChart content={{
                                        showLegend:false,
                                        backgroundColor:content.colors,
                                        data:content.data,
                                        labels:content.labels,
                                    }}
                                    rotate={1}
                                    redraw={drawOnce}
                                    isEmpty={isEmpty}
                                />
                }
                </div>
                <div className='dpc-sync' style={{opacity:(loading) ? 0 : 1}}>
                    Last update {moment().format("DD-MM-YY hh:mma")}
                </div>
                <div className='dpc-link' style={{opacity:(loading) ? 0 : 1}}>
                    {
                        (content.link)
                            ?
                            <Link to={content.link}>See More</Link>
                            :
                            <div className='invisible'>No Link</div>
                    }
                </div>
            </div>
        )
    }
}

class DashboardLineChart extends React.Component{
    psaColors=[
        u.hexToRgb("#229dce"),
        u.hexToRgb("#37a7b6"),
        u.hexToRgb("#63c08a"),
        u.hexToRgb("#8ed75e"),
        u.hexToRgb("#a5e348"),
        u.hexToRgb("#cac9d0"),
    ];

    state={
        loading:true,
        loadText:"Preparing...",
        content:{
            datatsets:[],
            labels:[],
        },
        isEmpty:false,
        options:{
            responsive: true,
            maintainAspectRatio:false,
            showLines:true,
            spanGaps:false,
            plugins:{
              legend:{
                display:false,
              },
              datalabels:{
                  display:true,
                  align:"end",
                  anchor:"end",
                  offset:1,
                  font:{
                      weight:"bold",
                  }
              },
              tooltip:{
                  callbacks:{
                      title:(datasets)=>{
                          let titles=[];
                          for(var i=0; i<datasets.length; i++){
                              const title = (datasets[i].dataset.tooltipTitle) ? datasets[i].dataset.tooltipTitle[datasets[i].dataIndex] : datasets[i].label;
                              titles.push(title);
                          }
                          return titles;
                      }
                  }
              }
            },
        },
        showValues:true,
    };

    componentDidMount=()=>{
        if(this.props.data){
            this.setState({content:this.props.data,loading:false});
            this.drawOnce();
        }
        else{
            this.getChartData();
        }
    }

    drawOnce=()=>{
        this.setState({drawOnce:true});
        setTimeout(()=>{
            this.setState({drawOnce:false})
        },50);
    }

    getChartData=async ()=>{
        try{
            const response = await u.postAsync({
                url:(this.props.overrideURL) ? this.props.overrideURL : "/api/get-dashboard-content",
                data:{
                    type:this.props.type,
                    testDelay:500,
                }
            });

            let content=response.data;
            content.datasets = content.datasets.map((item)=>{
                if(item.borderColor=="gradient"){
                    item.borderColor=this.drawGradient;
                }
                return item;
            });
            this.props.onSetData(response.data,this.props.index);
            this.setState({content:content,loading:false});
            this.drawOnce();
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getGradient=(ctx, chartArea)=>{
        let width, height, gradient;
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (!gradient || width !== chartWidth || height !== chartHeight) {
          // Create the gradient because this is either the first render
          // or the size of the chart has changed
          width = chartWidth;
          height = chartHeight;
          gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
          gradient.addColorStop(0, this.psaColors[0].hex);
          gradient.addColorStop(0.5, this.psaColors[3].hex);
          gradient.addColorStop(1, this.psaColors[5].hex);
      }
      return gradient;
    }

    drawGradient=(context)=>{
         const chart = context.chart;
         const {ctx, chartArea} = chart;
         if (!chartArea) {
           // This case happens on initial chart load
           return;
         }
         return this.getGradient(ctx, chartArea);
    }

    render=()=>{
        const {content,options,loading,drawOnce}=this.state;
        return(
            <div className='dashboard-chart-container'>
                <div className='dpc-title'><b>{content.title}</b></div>
                <div className='dashboard-chart-content'>
                {
                        (loading)
                            ?
                            <div className='dpc-placeholder'>
                                <LoadGraphic active={true} text="Preparing..." grey={true}/>
                            </div>
                            :
                            <Line options={{
                                    ...options,
                                    scales:{
                                        x:{
                                            ticks: {
                                                autoSkip: true,
                                                autoSkipPadding: 20,
                                            },
                                            grid:{
                                                color:(this.state.showValues) ? "#f4f4f4" : undefined,
                                                borderColor:(this.state.showValues) ? "#f4f4f4" : undefined
                                            },
                                            stacked:(content.barType == "stacked")
                                        },
                                        y:{
                                            display:true,
                                            beginAtZero:(typeof content.beginAtZero != "undefined") ? content.beginAtZero : true,
                                            steps:5,
                                            grace:"10%",
                                            ticks:{
                                                callback:(value,index,ticks)=>{
                                                    return (this.state.showValues) ? "" : value;
                                                }
                                            },
                                            grid:{
                                                color:(this.state.showValues) ? "#f4f4f4" : undefined,
                                                borderColor:(this.state.showValues) ? "#f4f4f4" : undefined
                                            },
                                            stacked:(content.barType == "stacked")
                                        },
                                    },
                                    layout:{
                                        padding:{
                                            right:30,
                                            top:10,
                                        }
                                    },
                                }}
                                data={content}
                                redraw={drawOnce}
                                />
                }
                </div>
                <div className='dpc-sync' style={{opacity:(loading) ? 0 : 1}}>
                    Last update {moment().format("DD-MM-YY hh:mma")}
                </div>
                <div className='dpc-link' style={{opacity:(loading) ? 0 : 1}}>
                    {
                        (content.link)
                            ?
                            <Link to={content.link}>See More</Link>
                            :
                            <div className='invisible'>No Link</div>
                    }
                </div>
            </div>
        )
    }
}

class DashboardBarChart extends React.Component{
    psaColors=[
        u.hexToRgb("#229dce"),
        u.hexToRgb("#37a7b6"),
        u.hexToRgb("#63c08a"),
        u.hexToRgb("#8ed75e"),
        u.hexToRgb("#a5e348"),
        u.hexToRgb("#cac9d0"),
    ];

    state={
        loading:true,
        loadText:"Preparing...",
        content:{},
        isEmpty:true,
        options:{
            responsive: true,
            maintainAspectRatio:false,
            showLines:true,
            spanGaps:false,
            plugins:{
              legend:{
                display:false,
              },
              datalabels:{
                  display:true,
                  align:"end",
                  anchor:"end",
                  offset:1,
                  font:{
                      weight:"bold",
                  }
              },
              tooltip:{
                  callbacks:{
                      title:(datasets)=>{
                          let titles=[];
                          for(var i=0; i<datasets.length; i++){
                              const title = (datasets[i].dataset.tooltipTitle) ? datasets[i].dataset.tooltipTitle[datasets[i].dataIndex] : datasets[i].label;
                              titles.push(title);
                          }
                          return titles;
                      }
                  }
              }
            },
        },
        showValues:true,
    };

    componentDidMount=()=>{
        if(this.props.data){
            this.setState({content:this.props.data,loading:false});
            this.drawOnce();
        }
        else{
            this.getChartData();
        }
    }

    drawOnce=()=>{
        this.setState({drawOnce:true});
        setTimeout(()=>{
            this.setState({drawOnce:false})
        },50);
    }

    getChartData=async ()=>{
        try{
            const response = await u.postAsync({
                url:(this.props.overrideURL) ? this.props.overrideURL : "/api/get-dashboard-content",
                data:{
                    type:this.props.type,
                    testDelay:500,
                }
            });
            this.props.onSetData(response.data,this.props.index);
            this.setState({content:response.data,loading:false});
            this.drawOnce();
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    render=()=>{
        const {content,options,loading,drawOnce}=this.state;

        return(
            <div className='dashboard-chart-container'>
                <div className='dpc-title'><b>{content.title}</b></div>
                <div className='dashboard-chart-content'>
                    {
                        (this.state.loading)
                            ?
                            <div className='dpc-placeholder'>
                                <LoadGraphic active={true} text="Preparing..." grey={true}/>
                            </div>
                            :
                            <Bar options={{
                                ...options,
                                scales:{
                                    x:{
                                        grid:{
                                            color:(this.state.showValues) ? "#f4f4f4" : undefined,
                                            borderColor:(this.state.showValues) ? "#f4f4f4" : undefined
                                        },
                                        stacked:(content.barType == "stacked")
                                    },
                                    y:{
                                        display:true,
                                        beginAtZero:(typeof content.beginAtZero != "undefined") ? content.beginAtZero : true,
                                        steps:5,
                                        grace:"10%",
                                        ticks:{
                                            callback:(value,index,ticks)=>{
                                                return (this.state.showValues) ? "" : value;
                                            }
                                        },
                                        grid:{
                                            color:(this.state.showValues) ? "#f4f4f4" : undefined,
                                            borderColor:(this.state.showValues) ? "#f4f4f4" : undefined
                                        },
                                        stacked:(content.barType == "stacked")
                                    },
                                },
                                layout:{
                                    padding:{
                                        top:10,
                                        right:30,
                                    }
                                },
                            }}
                             data={content}
                             redraw={drawOnce}
                             />
                    }
                </div>
                <div className='dpc-sync' style={{opacity:(loading) ? 0 : 1}}>
                    Last update {moment().format("DD-MM-YY hh:mma")}
                </div>
                <div className='dpc-link' style={{opacity:(loading) ? 0 : 1}}>
                    {
                        (content.link)
                            ?
                            <Link to={content.link}>See More</Link>
                            :
                            <div className='invisible'>No Link</div>
                    }
                </div>
            </div>
        )
    }
}

class DashboardListChart extends React.Component{
    psaColors=[
        u.hexToRgb("#229dce"),
        u.hexToRgb("#37a7b6"),
        u.hexToRgb("#63c08a"),
        u.hexToRgb("#8ed75e"),
        u.hexToRgb("#a5e348"),
        u.hexToRgb("#cac9d0"),
    ];

    tableRows=6;

    state={
        loading:true,
        loadText:"Preparing...",
        content:{
            data:[],
            labels:[],
        },
        isEmpty:true,
    };

    componentDidMount=()=>{
        if(this.props.data){
            this.setState({content:this.props.data,loading:false});
        }
        else{
            this.getChartData();
        }
    }

    getChartData=async ()=>{
        try{
            const response = await u.postAsync({
                url:(this.props.overrideURL) ? this.props.overrideURL : "/api/get-dashboard-content",
                data:{
                    type:this.props.type,
                    testDelay:500,
                }
            });
            this.props.onSetData(response.data,this.props.index);
            this.setState({content:response.data,loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    render=()=>{
        const {content,loading}=this.state;
        let padLength = (this.tableRows - content.data.length);
        if(padLength < 0){
            padLength = 0;
        }
        const tablePadding=Array(padLength).fill("");

        return(
            <div className='dashboard-chart-container'>
                <div className='dpc-title'><b>{content.title}</b></div>
                <div className='dashboard-list-container'>
                {
                    (this.state.loading)
                        ?
                        <div className='dpc-placeholder'>
                            <LoadGraphic active={true} text="Preparing..." color="lightgrey" grey={true}/>
                        </div>
                        :
                        <table>
                            <thead className={(content.length > this.tableRows ? "oversize" : "")} style={{backgroundColor:content.colors}}>
                                <tr>
                                    {
                                        content.labels.map(
                                            (header,h)=>{
                                                return (
                                                    <th key={h}
                                                        style={{
                                                            backgroundColor:(header.backgroundColor) ? header.backgroundColor : this.psaColors[0].hex,
                                                            width:(header.width) ? header.width : undefined,
                                                            textAlign:header.textAlign,
                                                        }}
                                                        onClick={()=>{this.onSelectHeader(h)}}
                                                        >
                                                        {header.label}
                                                        {
                                                            (header.selected)
                                                                ?
                                                                <img src="images/app/nav-triangle.png" className={"dashboard-selected" + ((header.twice) ? " twice" : "")}/>
                                                                :
                                                                null
                                                        }
                                                    </th>
                                                )
                                            }
                                        )
                                    }
                                </tr>
                            </thead>
                            <tbody style={{maxHeight:(40*this.tableRows)+"px"}}>
                                {
                                    content.data.map(
                                        (row,ri)=>{
                                            return (
                                                <tr key={ri} 
                                                    className={"item " + (ri%2 == 0 ? "even" : "odd")}
                                                    style={{backgroundColor:(row.backgroundColor) ? row.backgroundColor : "undefined"}}
                                                    >
                                                    {
                                                        content.labels.map(
                                                            (header,j)=>{
                                                                return (
                                                                    <td key={(ri*content.labels.length) + j}
                                                                        style={{width:header.width,textAlign:header.textAlign}}>
                                                                        {
                                                                            (header.type)
                                                                                ?
                                                                                null
                                                                                :
                                                                                row[header.field]

                                                                        }
                                                                        {
                                                                        (header.type == "datetime")
                                                                            ?
                                                                            moment(row[header.field]).format("DD MMM YY (HH:mm)")
                                                                            :
                                                                            null

                                                                        }
                                                                        {
                                                                            (header.type == "date")
                                                                            ?
                                                                            moment(row[header.field]).format("DD MMM YY")
                                                                            :
                                                                            null
                                                                        }
                                                                    </td>
                                                                )
                                                            }
                                                    )
                                                    }
                                                </tr>
                                            )
                                        }
                                    )
                                }
                                {
                                    tablePadding.map(
                                        (emptyRow,ei)=>{
                                            return(
                                                <tr key={ei} className={"item " + ((content.data.length + ei)%2 == 0 ? "even" : "odd")}>
                                                    {
                                                    content.labels.map(
                                                        (header,j)=>{
                                                            return (
                                                                <td key={(ei*content.labels.length) + j}>
                                                                        <div className="pad">NONE</div>
                                                                </td>
                                                            )
                                                        }
                                                    )
                                                }
                                                </tr>
                                            )
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                }
                </div>
                <div className='dpc-sync' style={{opacity:(loading) ? 0 : 1}}>
                    Last update {moment().format("DD-MM-YY hh:mma")}
                </div>
                <div className='dpc-link' style={{opacity:(loading) ? 0 : 1}}>
                    <Link to={content.link}>See More</Link>
                </div>
            </div>
        )
    }
}